module.exports = __webpack_public_path__ + "img/HQ-PA1W1T2RUH-V2.7f0bb24c.jpg";